// extracted by mini-css-extract-plugin
export default {"coolClass":"Notifications_coolClass__h67sB","gridCustomWidth":"Notifications_gridCustomWidth__5YnKW"};